import supplierSelect from './main.vue'

/* istanbul ignore next */
supplierSelect.install = function(Vue) {
  Vue.component(supplierSelect.name, supplierSelect)
}

export default supplierSelect
